import React, { ReactElement, ReactNode } from "react";
import styles from "./button.module.scss";

export function Button({
    className = "",
    children,
    onClick,
    icon,
    href,
    target,
    backgroundColor,
    style,
}: {
    className?: string;
    children: ReactNode;
    onClick?: () => void;
    icon?: ReactElement;
    target?: React.HTMLAttributeAnchorTarget | undefined;
    href?: string;
    backgroundColor?: string;
    style?: React.CSSProperties | undefined;
}): ReactElement {
    return href ? (
        <a
            style={{ backgroundColor, ...style }}
            target={target}
            href={href}
            className={`${styles["button"]} ${className ?? ""}`}
        >
            <span className={styles["inner"]}>
                <span className={styles["label"]}>{children}</span>
                <span className={styles["icon"]}>{icon}</span>
            </span>
        </a>
    ) : (
        <button
            style={{ backgroundColor, ...style }}
            onClick={onClick}
            className={`${styles["button"]}  ${className ?? ""}`}
        >
            <span className={styles["inner"]}>
                <span className={styles["label"]}>{children}</span>
                <span className={styles["icon"]}>{icon}</span>
            </span>
        </button>
    );
}
